/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  HERC20Logic,
  HERC20LogicInterface,
} from "../../../../contracts/dependant/erc20/HERC20Logic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type HERC20LogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HERC20LogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HERC20Logic__factory extends ContractFactory {
  constructor(...args: HERC20LogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<HERC20Logic> {
    return super.deploy(overrides || {}) as Promise<HERC20Logic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): HERC20Logic {
    return super.attach(address) as HERC20Logic;
  }
  override connect(signer: Signer): HERC20Logic__factory {
    return super.connect(signer) as HERC20Logic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HERC20LogicInterface {
    return new utils.Interface(_abi) as HERC20LogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HERC20Logic {
    return new Contract(address, _abi, signerOrProvider) as HERC20Logic;
  }
}
